import { ActivityLog } from "../services/superAdmin/adminActivityLogService";

const positiveId = (raw: unknown): number | null => {
  const id = typeof raw === "number" ? raw : Number(raw);
  return Number.isFinite(id) && id > 0 ? id : null;
};

export const resolveTenantIdFromLog = (log: ActivityLog): number | null => {
  for (const payload of [log.new_values, log.old_values]) {
    const id = positiveId(payload?.tenant_id);
    if (id != null) {
      return id;
    }
  }

  const routeMatch = String(log.route ?? "").match(/tenants\/(\d+)/);
  if (routeMatch) {
    return positiveId(routeMatch[1]);
  }

  return null;
};

/**
 * Conta Adatis (`global_identities.id`) em logs `accounts.*`.
 * Prefer identity_id; fallback route `/accounts/{id}`; last resort payload `id` só em actions accounts.*.
 */
export const resolveAccountIdFromLog = (log: ActivityLog): number | null => {
  for (const payload of [log.new_values, log.old_values]) {
    const fromIdentity = positiveId(payload?.identity_id);
    if (fromIdentity != null) {
      return fromIdentity;
    }
  }

  const routeMatch = String(log.route ?? "").match(/accounts\/(\d+)/);
  if (routeMatch) {
    return positiveId(routeMatch[1]);
  }

  if (String(log.action ?? "").startsWith("accounts.")) {
    for (const payload of [log.new_values, log.old_values]) {
      const fromId = positiveId(payload?.id);
      if (fromId != null) {
        return fromId;
      }
    }
  }

  return null;
};
